import bootstrapApollo from 'legacy-src/bootstrap/apollo';
import createRootReducer from 'legacy-src/reducers';
import {
  createNetworkInterface,
  IntrospectionFragmentMatcher,
} from 'apollo-client';
import introspectionQueryResultData from 'legacy-src/fragmentTypes.json';

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData,
});

/**
 * Bootstrap Apollo.
 *
 * @type {ApolloClient}
 */
const networkInterface = createNetworkInterface({
  uri: `${FYM_BACKEND_URL}/graphql`,
});
const client = bootstrapApollo(networkInterface, fragmentMatcher);

/**
 * Create our redux store.
 *
 * @type {Function}
 */

const store = createRootReducer(client);
window.store = store;

export { store, client };
